import axios from "axios";
import React, { useEffect, useState } from "react";
import { apiKey } from "../../../config/config";
import MessageCard from "../../../components/AdminCards/MessageCard";
import { FaPlus } from "react-icons/fa6";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

function Language() {
  const user = JSON.parse(localStorage.getItem("rms-admin"));
  const [translations, setTranslations] = useState([]);
  const [filteredTranslations, setFilteredTranslations] = useState([]);
  const [pageLoading, setPageLoading] = useState(true);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    axios
      .get(`${apiKey}/api/rms/admin/language`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      })
      .then((res) => {
        const langEn = JSON.parse(res.data[0].text_en || "{}");
        const langAr = JSON.parse(res.data[0].text_ar || "{}");
        const combined = Object.keys(langEn).map((key) => ({
          key,
          en: langEn[key],
          ar: langAr[key],
          isSaved: true, // Mark as already saved
        }));
        setTranslations(combined);
        setFilteredTranslations(combined);
      })
      .catch((err) => {
        setError(err?.response?.data?.message || "Error occurred!");
      })
      .finally(() => {
        setPageLoading(false);
      });
  }, [user?.token]);

  const handleAddRow = () => {
    setFilteredTranslations((prev) => [
      ...prev,
      { key: "", en: "", ar: "", isSaved: false }, // New row is not saved
    ]);
  };

  const handleInputChange = (index, field, value) => {
    setFilteredTranslations((prev) =>
      prev.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleSearch = (e) => {
    const searchTerm = e.target.value.toLowerCase();
    const filtered = translations.filter(
      (item) =>
        item.key.toLowerCase().includes(searchTerm) ||
        item.en.toLowerCase().includes(searchTerm) ||
        item.ar.toLowerCase().includes(searchTerm)
    );
    setFilteredTranslations(filtered);
  };

  const handleSave = (e) => {
    e.preventDefault();

    const langEn = {};
    const langAr = {};

    const allTranslations = [
  ...translations.filter((t) => !filteredTranslations.find((f) => f.key === t.key)),
  ...filteredTranslations
];


    allTranslations.forEach(({ key, en, ar }) => {
      if (key.trim() !== "") {
        langEn[key] = en;
        langAr[key] = ar;
      }
    });
    
    setLoading(true);
    axios
      .put(
        `${apiKey}/api/rms/admin/language/1`,
        {
          text_en: JSON.stringify(langEn),
          text_ar: JSON.stringify(langAr),
        },
        {
          headers: {
            Authorization: `Bearer ${user?.token}`,
          },
        }
      )
      .then(() => {
        toast.success("Language updated successfully!", {
          position: "bottom-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message || "Failed to update language!",
          {
            position: "bottom-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          }
        );
      })
      .finally(() => {
        setLoading(false);
      });
  };

  if (pageLoading) {
    return (
      <div className="absolute top-0 left-0 w-full h-full grid place-items-center">
        <img src="/assets/gif/dash2.gif" alt="" />
      </div>
    );
  }

  if (error) {
    return <MessageCard error={error} />;
  }

  return (
    <main>
      <div className="relative my-16 flex flex-col min-w-0 break-words w-full mb-6 shadow-lg bg-white rounded-lg p-4 border-0">
        <div className="flex justify-between items-center mb-4">
          <h1 className="text-d-bg-text text-2xl">Language</h1>
        </div>

        <div className="w-full relative">
          <div className="flex justify-end mb-4 bg-white w-full sticky top-4 z-10 p-4 shadow rounded">
            <input
              type="text"
              className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-64"
              placeholder="Search..."
              onChange={handleSearch}
            />
          </div>
          <form onSubmit={handleSave} className="w-full">
            <div className="grid grid-cols-3 text-xl font-medium text-d-bg-text gap-4">
              <h3>Key</h3>
              <h3>English</h3>
              <h3>Arabic</h3>
            </div>
            <div className="grid grid-cols-3 gap-4 mt-4">
              {filteredTranslations.map((item, index) => (
                <React.Fragment key={index}>
                  <input
                    type="text"
                    className={`px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full ${
                      item.isSaved ? "bg-gray-100" : "bg-white"
                    }`}
                    placeholder="Key"
                    value={item.key}
                    onChange={(e) =>
                      handleInputChange(index, "key", e.target.value)
                    }
                    disabled={item.isSaved} // Disable if already saved
                  />
                  <input
                    type="text"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="English"
                    value={item.en}
                    onChange={(e) =>
                      handleInputChange(index, "en", e.target.value)
                    }
                  />
                  <input
                    type="text"
                    className="px-2 py-2 placeholder-blueGray-300 text-blueGray-600 relative bg-white rounded text-sm shadow outline-none focus:outline-none focus:shadow-outline w-full"
                    placeholder="Arabic"
                    value={item.ar}
                    onChange={(e) =>
                      handleInputChange(index, "ar", e.target.value)
                    }
                  />
                </React.Fragment>
              ))}
            </div>
            <div className="flex justify-end items-center mt-4">
              <button
                type="button"
                onClick={handleAddRow}
                className="bg-d-cat-btn text-white text-sm px-3 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 duration-150 w-fit"
              >
                <FaPlus />
              </button>
            </div>
            <span className="w-full bg-d-bg h-1 my-2 inline-block"></span>
            <div className="flex gap-2">
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit relative"
                type="submit"
              >
                {loading && (
                  <span className="absolute top-0 left-0 w-full h-full py-1 px-3 bg-black bg-opacity-50">
                    <img
                      className="w-4 mx-auto"
                      src="https://i.gifer.com/ZKZx.gif"
                      alt=""
                    />
                  </span>
                )}
                Submit
              </button>
              <button
                className="bg-d-cat-btn text-white text-sm px-3 py-1 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150 text-center w-fit"
                type="button"
                onClick={() => navigate(-1)}
              >
                Back
              </button>
            </div>
          </form>
        </div>
      </div>
    </main>
  );
}

export default Language;
